import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

function accountHome(accountType) {
  if (accountType === 'parent') {
    return '/parent';
  }

  if (
    accountType === 'teacher' ||
    accountType === 'enseignant'
  ) {
    return '/enseignant';
  }

  if (accountType === 'administration') {
    return '/dashboard';
  }

  return '/login';
}

export default function ProtectedRoute({
  permission,
  accountType,
  children
}) {
  const location = useLocation();

  const {
    user,
    loading,
    can,
    profile,
    accountType: currentAccountType
  } = useAuth();

  if (loading) {
    return (
      <div className="screen-center">
        Chargement de Le Défi…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={
          accountType === 'teacher'
            ? '/connexion-enseignant'
            : '/login'
        }
        replace
      />
    );
  }

  if (
    accountType &&
    currentAccountType !== accountType
  ) {
    return (
      <Navigate
        to={accountHome(currentAccountType)}
        replace
      />
    );
  }

  const teacherFirstAccessIncomplete =
    currentAccountType === 'teacher' &&
    (
      profile?.mustChangePassword === true ||
      Number(profile?.teacherOnboardingVersion || 0) < 1 ||
      Number(profile?.teacherNotice?.schemaVersion || 0) < 1 ||
      profile?.teacherNotice?.confirmationAccepted !== true
    );

  if (
    accountType === 'teacher' &&
    teacherFirstAccessIncomplete &&
    location.pathname !== '/enseignant'
  ) {
    return <Navigate to="/enseignant" replace />;
  }

  if (
    permission &&
    !can(permission)
  ) {
    return (
      <Navigate
        to="/403"
        replace
      />
    );
  }

  return children;
}